import { ProductPricesRendererPrice } from '../../../../products/prices/interfaces/product-prices.interfaces';
import { Color } from '../../../../products/product.types.v2';
import { ProductCardsBlockColor, ProductCardsBlockPrice } from './productCardsBlock.types';

export const PRODUCT_CARDS_LIMIT = 10;

export type ProductCardsColorOption = Omit<Color, 'code'>;

export const toColorOptions = (colors: ProductCardsBlockColor[]): ProductCardsColorOption[] =>
  colors.map((color) => ({
    id: color.id,
    productColorId: color.productColorId,
    name: color.name,
    isImage: color.isImage,
    hexcode: color.hexcode ?? undefined,
    imageUrl: color.imageUrl ?? undefined,
  }));

export const findColorOption = (
  colors: ProductCardsColorOption[],
  productColorId: string,
): ProductCardsColorOption | undefined =>
  colors.find((color) => color.productColorId === productColorId);

export const toRendererPrices = (prices: ProductCardsBlockPrice[]): ProductPricesRendererPrice[] =>
  prices.map((price) => ({
    wholesalePrice: price.wholesalePrice,
    promotionalPrice: price.promotionalPrice ?? undefined,
    retailPrice: price.retailPrice ?? undefined,
  }));
